/**
 * Sif Starter Theme - Main Entry Point
 *
 * This file is the entry point for Vite build
 * It imports Tailwind CSS and any additional JavaScript
 */

// Import Tailwind CSS
import './main.css';

// Theme JavaScript
console.log('[Sif Starter Theme] Loaded successfully');

// You can add your custom JavaScript here
// Example: Alpine.js, GSAP animations, custom interactions, etc.
